<template>
	<div>
		<router-view/>
	</div>
</template>
<script>
import {signUpTrackingApi} from "@/common/api/signUpTracking";
import {registrationApi} from "@/common/api/registrationApi";
import {mapActions, mapGetters} from "vuex";
import {enumDef} from "@/common/enumDefs";
import {navigationPaths} from "@/common/navigation/navigationPaths";

export default {
	created() {
		if (this.$route.path !== navigationPaths.register.base) {
			return;
		}

		if (this.signUpLastCompletedStep > 0) {
			let option = {
				msg: this.$t("signUp.activeRegistration.confirm.text"),
				confirmButtonText: this.$t("signUp.activeRegistration.continue"),
				cancelButtonText: this.$t("signUp.activeRegistration.new"),
				confirmFun: this.continueWithExistingProcess,
				cancelFun: this.startNewProcess
			};
			this.confirmMeg(option, true);
		} else {
			this.startNewProcess();
		}
	},
	computed: {
		...mapGetters({
			signUpReferrer: "local/signUpReferrer",
			signUpCurrentStep: "local/signUpCurrentStep",
			signUpLastCompletedStep: "local/signUpLastCompletedStep"
		}),
	},
	methods: {
		...mapActions({
			clearSignUp: "local/clearSignUp",
			setSignUpSettings: "local/setSignUpSettings",
			setSignUpReferrer: "local/setSignUpReferrer"
		}),
		startNewProcess() {
			signUpTrackingApi.trackStart();

			this.clearSignUp();
			this.handleReferrer(() => {
				this.redirect(enumDef.signUpStep.orderedList()[0]);
			});
		},
		continueWithExistingProcess() {
			this.redirect(this.signUpCurrentStep);
		},
		redirect(step) {
			this.$router.replace(enumDef.signUpStep.path(step));
		},
		handleReferrer(callback) {
			let { query } = this.$route;

			if (!query.code) {
				callback();
				return;
			}

			let signUpReferrer = {
				invitationCode: query.code,
				partnerCustomerId: query.partnerCustomerId,
				redirectUrl: query.redirectUrl,
			};

			registrationApi.checkInvitationCode(signUpReferrer.invitationCode)
				.then(() => {
					this.saveSignUpReferrer(signUpReferrer, true);
					registrationApi.getSettings(signUpReferrer.invitationCode)
						.then(this.saveSettings)
						.finally(callback);
				})
				.catch(() => {
					this.saveSignUpReferrer(signUpReferrer, false);
					callback();
				});
		},
		saveSettings(settings) {
			this.setSignUpSettings({
				requiresUserPassword: settings.requiresUserPassword
			});
		},
		saveSignUpReferrer(signUpReferrer, isValid) {
			this.setSignUpReferrer({
				...signUpReferrer,
				invitationCodeIsValid: isValid,
			});
		}
	}
};
</script>
